import { render, staticRenderFns } from "./HeroImg.vue?vue&type=template&id=0c167c04&"
import script from "./HeroImg.vue?vue&type=script&lang=js&"
export * from "./HeroImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports